export const getImageUrl = (imagePath, type = '') => {
  if (!imagePath) return '';
  
  console.log('Original image path:', imagePath, 'Type:', type);
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // If it already contains the correct path, return with server URL
  if (imagePath.includes('uploads/')) {
    // Check if it's already a full path and avoid duplication
    if (imagePath.startsWith('uploads/')) {
      return `http://localhost:5000/${imagePath}`;
    } else {
      return `http://localhost:5000${imagePath}`;
    }
  }
  
  // For properties
  if (type === 'property') {
    return `http://localhost:5000${imagePath}`;
  }
  
  // For hotels - add the correct path
  if (type === 'hotel') {
    return `http://localhost:5000/${imagePath}`;
  }
  
  // Default case - assume it's a relative path from uploads
  return `http://localhost:5000/uploads/${imagePath}`;
};

export const handleImageError = (e, setError) => {
  console.error('Image failed to load:', e.target.src);
  if (setError) setError(true);
  
  // Set a fallback image
  e.target.src = 'http://localhost:5000/uploads/default-image.jpg';
  
  // Apply styles for broken images
  e.target.style.backgroundColor = '#f5f5f5';
  e.target.style.display = 'flex';
  e.target.style.alignItems = 'center';
  e.target.style.justifyContent = 'center';
  e.target.style.color = '#ccc';
  e.target.style.fontSize = '16px';
  e.target.style.fontWeight = 'bold';
};